import { useEffect, useState } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_CONFIGURATION_CONFIG_CENTER } from "../../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const ConfigurationCenterController = () => {
    const [whatsAppData, setWhatsAppData] = useState(null);
    const [whatsAppError, setWhatsAppError] = useState('');
    const [whatsAppLoading, setWhatsAppLoading] = useState(false);

    const [emailData, setEmailData] = useState(null);
    const [emailError, setEmailError] = useState('');
    const [emailLoading, setEmailLoading] = useState(false);

    const [smsData, setSmsData] = useState(null);
    const [smsError, setSmsError] = useState('');
    const [smsLoading, setSmsLoading] = useState(false);
    const pageName = "ConfigurationCenterController";

    const [whatsAppStatus, setWhatsAppStatus] = useState(0);

    const { setIsLoginPopup } = useTheme();

    useEffect(() => {
        const whatsAppStatus = JSON.parse(localStorage.getItem('whatsAppStatus'));
        setWhatsAppStatus(whatsAppStatus);
        if (whatsAppStatus === 1) {
            fetchWhatsAppConfig();
        }
    }, [])

    const tabs = ['Email', 'SMS'];
    if (whatsAppStatus === 1) {
        tabs.unshift('WhatsApp');
    }

    const fetchConfig = async ({ op, action_type, setLoading, setError, setData, methodName }) => {
        setLoading(true);
        setError('');
        setData(null);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                op: op,
                action_type: action_type,
                emp_id_auth: storedUser?.emp_id,
            };

            const response = await postData(ORG_CONFIGURATION_CONFIG_CENTER, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ && Object.keys(responseData.dataJ).length > 0) {
                            setData(responseData?.dataJ);
                        } else {
                            setError(responseData?.info || "No Configuration is available.");
                            logFrontendException(storedUser?.emp_id, pageName, methodName, responseData?.info);
                        }
                    } else {
                        setError(responseData?.info || "Failed to fetch configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, methodName, responseData?.info);
                    }
                } else {
                    setError(responseData?.info || "Unable to fetch configuration.Please try again later.");
                    logFrontendException(storedUser?.emp_id, pageName, methodName, responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, methodName, response || '');
            } else {
                setError("Failed to fetch configuration.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, methodName, response || '');
            }
        } catch (err) {
            setError("Unable to fetch configuration.Please check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, methodName, err);
        } finally {
            setLoading(false);
        }
    };

    const fetchWhatsAppConfig = () =>
        fetchConfig({
            op: 'whatsapp',
            action_type: 'get_whatsapp_config',
            setLoading: setWhatsAppLoading,
            setError: setWhatsAppError,
            setData: setWhatsAppData,
            methodName: 'fetchWhatsAppConfig'
        });

    const fetchEmailConfig = () =>
        fetchConfig({
            op: 'email',
            action_type: 'get_email_config',
            setLoading: setEmailLoading,
            setError: setEmailError,
            setData: setEmailData,
            methodName: 'fetchEmailConfig'
        });

    const fetchSmsConfig = () =>
        fetchConfig({
            op: 'sms',
            action_type: 'get_sms_config',
            setLoading: setSmsLoading,
            setError: setSmsError,
            setData: setSmsData,
            methodName: 'fetchSmsConfig'
        });

    useEffect(() => {
        fetchEmailConfig();
        fetchSmsConfig();
    }, []);

    return {
        whatsAppData,
        whatsAppError,
        whatsAppLoading,

        emailData,
        emailError,
        emailLoading,

        smsData,
        smsError,
        smsLoading,
        fetchWhatsAppConfig,
        fetchEmailConfig,
        fetchSmsConfig,
        whatsAppStatus,
        tabs,
    };
};

export default ConfigurationCenterController;
